import { Colors as C } from '../constants/Colors.js';

export const PALETTES = [
  [C.dark, C.gold],
  ['#0f1923', '#5DCAA5'],
  ['#1f0a1f', '#a89cf7'],
  ['#0a1628', '#5b9bd5'],
  ['#1a0f0f', '#e08060'],
  ['#0f1a0f', '#7ec87e'],
  ['#1a1520', '#d4a0d4'],
  ['#150f05', '#d4a050'],
  ['#0a1a1a', '#5DCAA5'],
];

/** Slides de texto/gradiente del hero (el archivo `public/banner_hero.*` se resuelve aparte). */
export const BANNERS_HERO_GRADIENTS = [
  {
    id: 1,
    bg: `linear-gradient(135deg, ${C.dark} 0%, #15121c 50%, #1f1a12 100%)`,
    tag: 'NOVEDAD',
    title: 'Colecciones de Jazz',
    sub: 'Miles Davis, Coltrane, Evans',
    color: C.gold,
  },
  {
    id: 2,
    bg: `linear-gradient(135deg, #101018 0%, ${C.dark} 45%, #252014 100%)`,
    tag: 'SUBASTAS',
    title: 'Esta semana en subasta',
    sub: 'Discos verificados · Pujas anónimas',
    color: C.goldLight,
  },
  {
    id: 3,
    bg: `linear-gradient(135deg, #120e0a 0%, #1a1410 55%, #221a14 100%)`,
    tag: 'TENDENCIA',
    title: 'Rock Clásico 70s & 80s',
    sub: 'Pink Floyd, Led Zeppelin, The Doors',
    color: C.gold,
  },
];

/** @deprecated Usar `BANNERS_HERO_GRADIENTS` + resolución `banner_hero` en `useMarketplaceHome`. */
export const BANNERS_HERO = BANNERS_HERO_GRADIENTS;

export const MARKET_SORT_OPTIONS = [
  { value: 'recientes', label: 'Novedades (últimos añadidos)' },
  { value: 'recomendaciones', label: 'Recomendaciones (partners)' },
  { value: 'precio_asc', label: 'Precio: menor a mayor' },
  { value: 'precio_desc', label: 'Precio: mayor a menor' },
  { value: 'artista', label: 'Artista (A–Z)' },
  { value: 'titulo', label: 'Nombre del título (A–Z)' },
  { value: 'anio_asc', label: 'Año: más antiguo' },
  { value: 'anio_desc', label: 'Año: más reciente' },
  { value: 'estado', label: 'Condición (M → P, mejor primero)' },
];
